import React from 'react';
import { Reveal } from './Reveal';
import { BookOpenIcon, GhostIcon, SearchCheckIcon, UnplugIcon, PenLineIcon, CalendarCheckIcon } from 'lucide-react';
const ITEMS = [{
  icon: BookOpenIcon,
  title: 'La Guía Maestra PDF',
  body: '65 páginas de confrontación honesta y sanación real.'
}, {
  icon: GhostIcon,
  title: 'Anatomía del Fantasma',
  body: 'Por qué tu cerebro prefiere el dolor de ellos que la paz de la soledad.'
}, {
  icon: SearchCheckIcon,
  title: 'La Auditoría del Chat',
  body: 'El ejercicio definitivo para ver la verdad detrás de las migajas de afecto.'
}, {
  icon: UnplugIcon,
  title: 'El Protocolo de Desanclaje',
  body: 'Pasos físicos y digitales para limpiar tu entorno de "fantasmas".'
}, {
  icon: PenLineIcon,
  title: 'Tu Nueva Narrativa',
  body: 'Cómo redefinir tus estándares para no volver a aceptar un amor a medias.'
}, {
  icon: CalendarCheckIcon,
  title: 'Hoja de Ruta de 21 Días',
  body: 'Ejercicios diarios de escritura y acción.'
}];
export function WhatYouGet() {
  return <section className="w-full bg-midnight py-24" data-id="element-150">
      <div className="mx-auto max-w-5xl px-6" data-id="element-151">
        <Reveal data-id="element-152">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-rose-glow" data-id="element-153">
            Lo que recibes
          </p>
          <h2 className="mt-4 font-display text-3xl font-semibold text-cream sm:text-4xl" data-id="element-154">
            Todo lo que necesitas para cerrar el ciclo.
          </h2>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-155">
          {ITEMS.map((item, i) => <Reveal key={item.title} delay={i % 3 * 0.08} data-id="element-156">
              <div className="group h-full rounded-2xl border border-white/10 bg-white/[0.03] p-7 transition-colors hover:border-rose-glow/40" data-id="element-157">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-rose-glow/15" data-id="element-158">
                  <item.icon className="h-5 w-5 text-rose-glow" data-id="element-159" />
                </div>
                <h3 className="mt-5 font-display text-xl font-semibold text-cream" data-id="element-160">
                  {item.title}
                </h3>
                <p className="mt-2 leading-relaxed text-muted" data-id="element-161">{item.body}</p>
              </div>
            </Reveal>)}
        </div>
      </div>
    </section>;
}